import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./button.html";
class C360Button extends LightningElement {
  constructor(...args) {
    super(...args);
    this.label = void 0;
    this.variant = void 0;
    this.iconName = void 0;
    this.iconPosition = void 0;
    this.className = void 0;
    this.changeBlur = void 0;
    this.changeFocus = void 0;
    this._disabled = false;
  }
  get disabled() {
    return this._disabled;
  }
  set disabled(value) {
    this._disabled = value;
    if (this._disabled) {
      this.setAttribute('disabled', '');
    } else {
      this.removeAttribute('disabled');
    }
  }
  onFocus(event) {
    event.preventDefault();
    if (this.changeFocus) {
      this.changeFocus();
    }
  }
  onBlur(event) {
    event.preventDefault();
    if (this.changeBlur) {
      this.changeBlur();
    }
  }
  /*LWC compiler v7.1.3*/
}
C360Button.delegatesFocus = true;
_registerDecorators(C360Button, {
  publicProps: {
    label: {
      config: 0
    },
    variant: {
      config: 0
    },
    iconName: {
      config: 0
    },
    iconPosition: {
      config: 0
    },
    className: {
      config: 0
    },
    changeBlur: {
      config: 0
    },
    changeFocus: {
      config: 0
    },
    disabled: {
      config: 3
    }
  },
  fields: ["_disabled"]
});
const __lwc_component_class_internal = _registerComponent(C360Button, {
  tmpl: _tmpl,
  sel: "c360-button",
  apiVersion: 62
});
export default __lwc_component_class_internal;